<template>
    <v-item v-slot:default="{ active, toggle }">
    <v-img
            v-if="mediaItem.type < 2 "
            :src="mediaItem.link"
            height="120"
            class="text-right pa-2"
            @click="toggle"
    >
        <v-overlay absolute :value=active>
            <v-btn
                    small
                    icon
                    :dark=active
            >
                <v-icon>
                    {{ active ? 'done' : 'keyboard' }}
                </v-icon>
            </v-btn>
        </v-overlay>
    </v-img>
    <v-card v-else flat @click="toggle">
        <v-card-text class="text-truncate pa-1">
            <p class="text-center mb-1">
                <v-icon large>insert_drive_file</v-icon>
            </p>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="on">{{mediaItem.caption}}</span>
                </template>
                <span>{{mediaItem.caption}}</span>
            </v-tooltip>
            <v-overlay absolute :value=active>
                <v-btn
                        small
                        icon
                >
                    <v-icon>
                        {{ active ? 'done' : 'keyboard' }}
                    </v-icon>
                </v-btn>
            </v-overlay>
        </v-card-text>
    </v-card>
    </v-item>
</template>

<script>
export default {
    name: 'DocumentCard',
    props: {
        mediaItem: Object
    }
}
</script>

<style scoped>

</style>
